import React from 'react'

export default function MyHistory() {
  return (
    <div>MyHistory</div>
  )
}
